// src/properties/propertyTypesApi.ts
import { apiClient } from "@maat/api-base";
var propertyTypesApi = {
  async getPropertyTypes(popular) {
    return await apiClient.get("/main/api/property-types", {
      params: popular ? { popular: true } : void 0
    });
  },
  // Admin: toggle the popularity flag (requireAdmin-gated).
  async setPopular(id, isPopular) {
    return await apiClient.patch(`/main/api/admin/property-types/${id}`, {
      is_popular: isPopular
    });
  }
};

export {
  propertyTypesApi
};
